import { Component, Input } from '@angular/core';
import { IconComponent } from 'components';

@Component({
	standalone: true,
	selector: 'navbar-icon-button',
	template: `
		<app-icon [type]="iconType" [size]="36">{{ icon }}</app-icon>
	`,
	imports: [IconComponent],
	styles: [
		`
			:host {
				app-icon {
					display: flex;
					transition: background-color 150ms;
					border-radius: 4px;
					cursor: pointer;

					&:hover {
						background-color: #f3f3f3;
					}
				}
			}
		`
	]
})
export class IconButtonComponent {
	@Input() icon!: string;
	@Input() iconType: 'mat' | 'svg' = 'svg';
}
